import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import Nav from "./Nav.jsx";
import Footer from "./Footer.jsx";
import "./home.css";
import "./Sales.css";
import StandardPageMain from "../Components/StandardCardMain.jsx";
import ReadOnlyLines from "../Components/ReadOnlyLines.jsx";
import useFetch from "../Components/UseFetch.jsx";
import {
  workOrders,
  workOrderTasks,
  workOrderSLines,
  companyDefault,
} from "../HelperFx/datalinks.js";

const REACT_UNAME = process.env.REACT_APP_API_USERNAME;
const REACT_PWD = process.env.REACT_APP_API_PASSWORD;
const REACT_DATA_URL = process.env.REACT_APP_API_DATA_URL;

const toDateInput = (value) => {
  if (!value) return "";
  const text = String(value);
  if (text.includes("0001-01-01") || text.startsWith("0001-")) return "";
  return text.slice(0, 10);
};

const mapHeader = (record) => ({
  ...record,
  issueDate: toDateInput(record.issueDate),
  startDate: toDateInput(record.startDate),
  completionDate: toDateInput(record.completionDate),
});

const ServiceOrder = () => {
  const location = useLocation();
  const token = btoa(`${REACT_UNAME}:${REACT_PWD}`);
  const docNo = location.state?.number || "";
  const [header, setHeader] = useState({});

  const headerUrl = docNo
    ? `${REACT_DATA_URL}${workOrders}?${companyDefault}&$filter=no eq '${docNo}'`
    : null;
  const { data: headerResponse } = useFetch(
    headerUrl || `${REACT_DATA_URL}${workOrders}?${companyDefault}&$top=0`,
    token,
  );

  useEffect(() => {
    const record = headerResponse?.value?.[0];
    if (record) setHeader(mapHeader(record));
  }, [headerResponse]);

  const fields = [
    { name: "no", label: "Document No.", type: "text", disabled: true },
    { name: "issueDate", label: "Issue Date", type: "date", disabled: true },
    { name: "machineType", label: "Machine Type", type: "text", disabled: true },
    { name: "machineNo", label: "Machine No.", type: "text", disabled: true },
    { name: "machine", label: "Machine", type: "text", disabled: true },
    {
      name: "maintenanceType",
      label: "Maintenance Type",
      type: "text",
      disabled: true,
    },
    { name: "startDate", label: "Start Date", type: "date", disabled: true },
    {
      name: "completionDate",
      label: "Completion Date",
      type: "date",
      disabled: true,
    },
    { name: "results", label: "Results", type: "text", disabled: true },
    {
      name: "functionalTests",
      label: "Functional Tests",
      type: "text",
      disabled: true,
    },
    { name: "status", label: "Status", type: "text", disabled: true },
    {
      name: "customerRating",
      label: "Customer Rating",
      type: "text",
      disabled: true,
    },
    {
      name: "ratingComment",
      label: "Rating Comment",
      type: "text",
      disabled: true,
    },
  ];

  const taskColumns = [
    { name: "description", label: "Description", type: "text" },
    { name: "status", label: "Status", type: "text" },
    { name: "remarks", label: "Remarks", type: "text" },
    { name: "startDate", label: "Start Date", type: "date" },
    { name: "completionDate", label: "Completion Date", type: "date" },
    { name: "durationInMinutes", label: "Duration In Minutes", type: "decimal" },
  ];

  const lineColumns = [
    { name: "type", label: "Type", type: "text" },
    { name: "no", label: "No", type: "text" },
    { name: "description", label: "Description", type: "text" },
    { name: "uom", label: "Unit Of Measure", type: "text" },
    { name: "qty", label: "Qty", type: "decimal" },
    { name: "unitCost", label: "Unit Cost", type: "decimal", format: "amount" },
    { name: "amount", label: "Amount", type: "decimal", format: "amount" },
  ];

  const tasksUrl = docNo
    ? `${REACT_DATA_URL}${workOrderTasks}?${companyDefault}&$filter=documentNo eq '${docNo}'`
    : null;
  const linesUrl = docNo
    ? `${REACT_DATA_URL}${workOrderSLines}?${companyDefault}&$filter=documentNo eq '${docNo}'`
    : null;

  if (!docNo) {
    return (
      <div className="Home">
        <Nav />
        <div className="dash-main settings-full">
          <div className="squote">
            <div className="firsttab px-4">Service Order</div>
            <p style={{ padding: 20 }}>No service order number was provided.</p>
          </div>
        </div>
        <Footer />
      </div>
    );
  }

  return (
    <div className="Home">
      <Nav />
      <div className="dash-main settings-full">
        <div className="squote">
          <div className="firsttab px-4">Service Order {docNo}</div>
          <div className="listTable">
            <StandardPageMain
              title={`Service Order - ${docNo}`}
              fields={fields}
              initialData={header}
              actions={[]}
              redirectTo="ServiceOrders"
              PreventEdit
              authToken={token}
            />
            <ReadOnlyLines
              apiUrl={tasksUrl}
              token={token}
              columns={taskColumns}
              title="Work Order Tasks"
            />
            <ReadOnlyLines
              apiUrl={linesUrl}
              token={token}
              columns={lineColumns}
              title="Work Order Lines"
            />
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default ServiceOrder;
